/**
 * Category selection grid for Black Friday page
 *
 * Renders top-level category buttons using CVA categoryCard variant.
 */

import { Button } from '../../../Theme'
import { useBlackFriday } from '../../state'

export function CategoryGrid() {
  const { categoryNames, selectedCategory, handleCategoryClick } = useBlackFriday()

  if (categoryNames.length === 0) return null

  return (
    <div className="grid grid-cols-2 gap-5 justify-items-center xl:grid-cols-4 xl:grid-rows-2">
      {categoryNames.map((categoryName) => (
        <Button
          key={categoryName}
          variant="categoryCard"
          size="categoryCard"
          onClick={() => handleCategoryClick(categoryName)}
          aria-pressed={selectedCategory?.name === categoryName}
        >
          {categoryName}
        </Button>
      ))}
    </div>
  )
}
